import Chrome from "./chrome.vue";

export default Chrome;
